export const SET_POLICY = 'SET_POLICY';
export const SET_POLICY_KIND_INVESTMENT = 'SET_POLICY_KIND_INVESTMENT';
export const SET_CHANGEITEMS_RESULT = 'SET_CHANGEITEMS_RESULT';
export const RESET_CHANGEITEMS_RESULT = 'RESET_CHANGEITEMS_RESULT';

export const mutations = {
    [SET_POLICY](state, payload) {
        state.policy = JSON.parse(JSON.stringify(payload));
    },
    [SET_POLICY_KIND_INVESTMENT](state, payload) {
        state.policyKindInvestment = payload;
    },
    [SET_CHANGEITEMS_RESULT](state, payload) {
        const {
            code,
            value,
        } = payload;
        state.changeItemsResult[code] = value;
    },
    [RESET_CHANGEITEMS_RESULT](state, payload) {
        state.changeItemsResult = payload;
    },
};
